import de from "@/messages/de";
import en from "@/messages/en";
import es from "@/messages/es";

const messages = {
    de, en, es
};

export default messages;
